import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/bookings/$id")({
  component: BookingLayout,
})

/**
 * Layout wrapper for booking routes that renders nested child routes.
 *
 * @returns A React element that renders the matched child route via an `Outlet`.
 */
function BookingLayout() {
  return <Outlet />
}
